import { headers } from "../../../config/config";
import { MESSAGE } from "../../../constants/api/message";
import { Member } from "../../../types/employee.types";
import { EnrollmentSchema } from "../../../types/enrollment.types";
import { GroupOwner } from "../../../types/groupOwner.types";
import { LogoSettings } from "../../../types/logoSettings.types";
import { Paycheck } from "../../../types/paycheck.types";
import { Theme } from "../../../types/theme.types";
import { request } from "../api";

const initialRoute = "pages";
const { get } = request;

export const getMemberPortalInitData = async (
	groupOwnerToken: string | null
): Promise<{
	member: Member;
	groupOwner: GroupOwner | null;
	paycheck: Paycheck;
	logoSettings: LogoSettings;
	theme: Theme;
	dependents: (Member & { enrollment: EnrollmentSchema })[];
}> => {
	try {
		const endpoint = `${initialRoute}/member-portal-init`;
		const token = localStorage.getItem("@jwt_member");
		const response = await get(
			endpoint,
			{
				...headers,
				Authorization: `Bearer ${token}`
			},
			{
				group_owner_token: groupOwnerToken
			}
		);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;

				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (err) {
		alert(err);
		throw err;
	}
};

export const getDependentPortalInitData = async (): Promise<{
	member: Member;
	logoSettings: LogoSettings;
	theme: Theme;
}> => {
	try {
		const endpoint = `${initialRoute}/member-portal-init/dependent`;
		const token = localStorage.getItem("@jwt_member");
		const response = await get(endpoint, {
			...headers,
			Authorization: `Bearer ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;

				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (err) {
		alert(err);
		throw err;
	}
};

export const memberPortalInit = {
	getMemberPortalInitData
};
